import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-exit-meeting-page',
  templateUrl: './exit-meeting-page.component.html'
})
export class ExitMeetingPageComponent implements OnInit {
  @Input() $transition$: any;

  stateParams: any;

  ngOnInit() {
    this.stateParams = this.$transition$.params();
  }
}
